<template>    
	<div class="container">
		<div class="loader-info" v-if="pageLoader">
			<img src="/static/prism_admin/images/prism_loader.gif" />
		</div>
        <div class="p_login">
            <div class="row d-flex align-items-center h_100">
            <div class="col-7 text-center">
                <img src="../../../../static/prism_admin/images/login.jpg" width="80%" />
                <div class="md-5 ">
	                <img src="../../../../static/prism_admin/images/powered_by_finvasia.png"  width="25%" />
	            </div>
            </div>
            <div class="col-5">
                <div class="sign_insec whitebox">
                    <div class="subtitle">
                        <h1>SIGN IN</h1>
                        <p>Please Enter Detail Below</p>    
                    </div>
                    <div class="form-group field-wrapper" :class="{error: validation.hasError('email')}">
                        <input placeholder=" " type="text" class="float-field" v-model="email"/>
                        <label class="float-label">Username</label>
                        <div class="message" style="color:red">
                            {{ validation.firstError('email') }}
                        </div>
                    </div>
                    <div class="form-group field-wrapper" :class="{error: validation.hasError('password')}">
                        
                        <input placeholder=" " type="password" class="float-field" v-model="password" @keyup.enter="login()"/>
                        <label class="float-label">Password</label>
                        <div class="message" style="color:red">
                            {{ validation.firstError('password') }}
                        </div>
                    </div>
                    <div class="form-group field-wrapper">
                        <button class="prism_btn w-100" v-on:click="login()">LOGIN</button>
                    </div>
                    <!-- <div class="mt-4 customnewcheckbox">
                        <div class="forgot_sec">
                            <label class="pull-left fancy_radiochk_btn">Remember Me
                            <input type="checkbox"><span class="checkmark"></span>
                            </label>
                            <router-link class="pull-right forgotpassword" :to="'/prism/forgot-password'" >
                            <lock-icon size="1.5x" class="custom-class"></lock-icon> Forgot Password
                            </router-link>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>                   
        </div>
	</div>
</template>
<script>
    //====================================================
    import Vue from 'vue';
    import SimpleVueValidation from 'simple-vue-validator';
    const Validator = SimpleVueValidation.Validator;
    Vue.use(SimpleVueValidation);
    //====================================================
	import { prismMixins } from '@/plugins/prism_admin'
  
    import * as types from '@/types'
    import { mapActions } from 'vuex'   
	import * as moment from 'moment';
    import LoginHeader from '../shared/login/login_header'
    import LoginLogo from '../shared/login/login_logo'
    import LoginFooter from '../shared/login/login_footer'
    import { LockIcon } from 'vue-feather-icons'
    export default {
        name: 'LOGIN',
		mixins: [prismMixins],
		components: {
             
            appLoginHeader : LoginHeader,
            appLoginLogo : LoginLogo,
            appLoginFooter : LoginFooter,
            LockIcon
        },
        data(){
			return {
				email:"",
				password:"",            
				
				
				pageLoader : false
			}
        },
        validators: {
            email: function(value){ return Validator.value(value).required();  },
            password: function(value){ return Validator.value(value).required();  }
        },
		methods:{
			...mapActions({
                _runLogin: types.RUN_USER_LOGIN
            }),
            login(){
                const _that = this
                this.$validate()
                .then(function (success){
                    if(success){
    					const r = _that.$router
    					_that._runLogin({
    						"email": _that.email,
    						"password": _that.password,                    
    						"parameter" : _that,
    						"router" :r
    					})
                    }
                })
        				
            }
		},
        created(){
            localStorage.clear()
        }
    }

</script>




// WEBPACK FOOTER //
// src/components/prism_admin/Users/login.vue